import { render } from "./ParceiroFilters.vue?vue&type=template&id=2a51d0f7"
import script from "./ParceiroFilters.vue?vue&type=script&lang=js"
export * from "./ParceiroFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__